import { useMemo } from 'react';
import {
  RepairRequestIDInfoType,
  RepairItemSelectInfoType,
  InsuranceResultInfoType,
  EstimateDetailInfoType,
  RepairItemSelectDataType,
} from '@/types/bodyAndPaint';

interface RepairItemSelectDataHookProps {
  ids: RepairRequestIDInfoType;
  insuranceResult?: InsuranceResultInfoType;
  estimateDetailList: EstimateDetailInfoType;
}
export const useRepairItemSelectData = ({
  ids,
  insuranceResult,
  estimateDetailList,
}: RepairItemSelectDataHookProps) => {
  const repairItemList: RepairItemSelectInfoType = useMemo(() => {
    return (estimateDetailList ?? []).reduce((list, estimate) => {
      if (estimate) {
        const selectItem = {
          id: estimate.id,
          repair_select: undefined,
          repair_item_name: estimate.name,
          is_insurance: estimate.is_insurance,
          repair_amount: estimate.repair_amount,
          applied_amount: estimate.applied_amount,
        };
        list.push(selectItem);
      }
      return list;
    }, [] as RepairItemSelectInfoType);
  }, [estimateDetailList]);

  const repairItemSelectData: RepairItemSelectDataType = useMemo(() => {
    return {
      ids: ids,
      insuranceResultInfo: insuranceResult,
      repairItemList: repairItemList,
    };
  }, [ids, insuranceResult, repairItemList]);
  return { repairItemSelectData };
};
